import { render, staticRenderFns } from "./tacPsycGauge.vue?vue&type=template&id=2d05bb40&scoped=true"
import script from "./tacPsycGauge.vue?vue&type=script&lang=ts"
export * from "./tacPsycGauge.vue?vue&type=script&lang=ts"
import style0 from "./tacPsycGauge.vue?vue&type=style&index=0&id=2d05bb40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d05bb40",
  null
  
)

export default component.exports